const _0 = "0px"
const _full = "100%"
const _min = "min-content"
const _max = "max-content"
const _fit = "fit-content"
const config = { "0": _0, "full": _full, "min": _min, "max": _max, "fit": _fit,  }
export { config as default, _0, _full, _min, _max, _fit }